module.exports = require('./helpers/bundle-url').getBundleURL('5D0wD') + "1F60D.827fe010.svg";